"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactQuery = require("@tanstack/react-query");
var _dispatchCartCountUpdated = _interopRequireDefault(require("../api/buy/carts/v2/utils/dispatch-cart-count-updated"));
var _dispatchCartUpdated = _interopRequireDefault(require("../api/buy/carts/v2/utils/dispatch-cart-updated"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var queryClient = new _reactQuery.QueryClient({
  queryCache: new _reactQuery.QueryCache({
    onSuccess: function onSuccess(data, query) {
      var _query$meta, _query$meta2;
      if ((_query$meta = query.meta) !== null && _query$meta !== void 0 && _query$meta.dispatchCartCountUpdated) {
        var _data$totals;
        (0, _dispatchCartCountUpdated["default"])((data === null || data === void 0 || (_data$totals = data.totals) === null || _data$totals === void 0 ? void 0 : _data$totals.quantity) || 0);
      }
      if ((_query$meta2 = query.meta) !== null && _query$meta2 !== void 0 && _query$meta2.dispatchCartUpdated) {
        (0, _dispatchCartUpdated["default"])();
      }
    }
  }),
  mutationCache: new _reactQuery.MutationCache({
    onSuccess: function onSuccess(data, variables, context) {
      var _context$meta, _context$meta2;
      if (context !== null && context !== void 0 && (_context$meta = context.meta) !== null && _context$meta !== void 0 && _context$meta.dispatchCartCountUpdated) {
        var _data$totals2;
        (0, _dispatchCartCountUpdated["default"])((data === null || data === void 0 || (_data$totals2 = data.totals) === null || _data$totals2 === void 0 ? void 0 : _data$totals2.quantity) || 0);
      }
      if (context !== null && context !== void 0 && (_context$meta2 = context.meta) !== null && _context$meta2 !== void 0 && _context$meta2.dispatchCartUpdated) {
        (0, _dispatchCartUpdated["default"])();
      }
    }
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity
    }
  }
});
var _default = exports["default"] = queryClient;